import { createApp } from 'vue'
import SearchOverlay from './SearchOverlay'

const el = '.kb-component--search-overlay'
const DOM = document.querySelector(el)

export default function (Store) {
    if (DOM) {
        Store.commit(
            'search/set_search_page_redirecturl',
            DOM.dataset.searchpageurl
        )
        Store.commit(
            'search/set_hide_autocomplete',
            (DOM.dataset.hideautocomplete?.toLowerCase() === 'true')
        )
    }
}
